import Moment from 'moment'
import Constants from '@constants'
import Datetime from '@src/filters/datetime'
import Duration from '@src/filters/duration'
import Bytes from '@src/filters/bytes'
import Hertz from '@src/filters/hertz'
import {
  getRootTranslator,
  getRootPluaralTranslator,
} from '@utils/get-module-translator'
const __t = getRootTranslator()
const __tc = getRootPluaralTranslator()

export function convertValueForDescription(inputType, value, field = {}) {
  // Handle expression values (object with expression and outputType)
  if (typeof value === 'object' && value !== null && value.expression) {
    return `${__t('using')} ${__t('expression')}`
  }

  // Handle reference values
  if (typeof value === 'string' && value.includes('$.')) {
    return `${__t('using')} ${__t('reference')}`
  }

  if (['datetime'].indexOf(inputType) >= 0) {
    if (
      value === Constants.CURRENT_DATE_TODAY ||
      value === Constants.CURRENT_DATE_VALUE
    ) {
      value = `${__t('current')} ${__t('date')}`
    } else {
      value = Datetime(value, undefined, (field.attributes || {}).allowTime)
    }
  }
  if (['dateTime'].indexOf(inputType) >= 0) {
    // convert value to date time
    if (
      value === Constants.CURRENT_DATE_TODAY ||
      value === Constants.CURRENT_DATE_VALUE
    ) {
      value = `${__t('current')} ${__t('date')}`
    } else {
      value = Datetime(value)
    }
  }
  if (['date'].indexOf(inputType) >= 0) {
    if (
      value === Constants.CURRENT_DATE_TODAY ||
      value === Constants.CURRENT_DATE_VALUE
    ) {
      value = `${__t('current')} ${__t('date')}`
    } else {
      // convert value to date
      value = Datetime(value, 'ddd, MMM DD, YYYY', false)
    }
  }
  if (['estimatedTime'].indexOf(inputType) >= 0) {
    const hours = Moment.duration(Math.abs(value), 'milliseconds').asHours()
    value = `${hours} ${__tc('hours', hours)}`
  }
  if (inputType === 'boolean') {
    value = value ? __t('yes') : __t('no')
  }
  if (
    ['tags', 'emails', 'checkbox', 'multiStringValue'].indexOf(inputType) >= 0
  ) {
    return (value || []).join(', ')
  }
  if (['bytes'].indexOf(inputType) >= 0) {
    value = Bytes(value, field.unit)
  }
  if (['hertz'].indexOf(inputType) >= 0) {
    value = Hertz(value, field.unit)
  }
  if (['timePicker'].indexOf(inputType) >= 0) {
    value = Duration(value)
  }
  if (['notifyBeforeHours'].indexOf(inputType) >= 0) {
    value = `${value.value || 0} ${__tc(value.timeUnit, value.value || 1)}`
  }
  if (['number'].indexOf(inputType) >= 0) {
    value = value === 0 ? '0' : value
  }
  if (['multiSelectDropdown'].indexOf(inputType) >= 0) {
    value = value.length <= 0 ? '---' : (value || []).join(', ')
  }
  if (['duration'].indexOf(inputType) >= 0) {
    value = Duration(value)
  }
  return value
}

export const getDropdownItemValue = (item) => {
  if ('key' in item) {
    return item.key
  }
  if ('value' in item) {
    return item.value
  }
  if ('id' in item) {
    return item.id
  }
}

export const getDropdownItemKeyExist = (item) => {
  if ('key' in item) {
    return 'key'
  }
  if ('value' in item) {
    return 'value'
  }
  if ('id' in item) {
    return 'id'
  }
}
